// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"barcode-1"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8 21H3V16M8 3H3V8M16 3H21V8M16 21H21V16","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M8 9V15M12 9V15M16 9V15","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Barcode1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'barcode-1',
    ref,
    icon: element,
  },
));

Barcode1Icon.displayName = 'Barcode1Icon';

export default Barcode1Icon;
